var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 11.428571,
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0a632f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05411e"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0-.001391h16v11.428571h-16z",
    fill: "url(#c)",
    mask: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0-.001391h4.571429v11.428571h-4.571429z",
    fill: "url(#a)",
    mask: "url(#d)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.31671604 6.76397806c-.55719223.45348274-1.25813684.72366186-2.01956534.72366186-1.81493394 0-3.28622864-1.53502374-3.28622864-3.42857146 0-1.89354771 1.4712947-3.42857143 3.28622864-3.42857143.7614285 0 1.46237311.27017906 2.01956534.7236618-.25298179-.06536946-.51940038-.10028518-.79450385-.10028518-1.64993996 0-2.98748061 1.2559285-2.98748061 2.80519481s1.33754065 2.80519478 2.98748061 2.80519478c.27510347 0 .54152206-.03491566.79450385-.10028518zm.02753935-2.11062387-.89567276.63850207.33047345-1.04914341-.88402964-.65452743 1.09991657-.00990422.34931238-1.04302227.34931238 1.04302227 1.09991657.00990422-.88402964.65452743.33047345 1.04914341z",
    fill: "#000",
    fillRule: "nonzero",
    transform: "matrix(.70710678 -.70710678 .70710678 .70710678 4.98342994505 5.11840454283)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.31671604 6.76397806c-.55719223.45348274-1.25813684.72366186-2.01956534.72366186-1.81493394 0-3.28622864-1.53502374-3.28622864-3.42857146 0-1.89354771 1.4712947-3.42857143 3.28622864-3.42857143.7614285 0 1.46237311.27017906 2.01956534.7236618-.25298179-.06536946-.51940038-.10028518-.79450385-.10028518-1.64993996 0-2.98748061 1.2559285-2.98748061 2.80519481s1.33754065 2.80519478 2.98748061 2.80519478c.27510347 0 .54152206-.03491566.79450385-.10028518zm.02753935-2.11062387-.89567276.63850207.33047345-1.04914341-.88402964-.65452743 1.09991657-.00990422.34931238-1.04302227.34931238 1.04302227 1.09991657.00990422-.88402964.65452743.33047345 1.04914341z",
    fill: "url(#a)",
    transform: "matrix(.70710678 -.70710678 .70710678 .70710678 4.98342994505 5.11840454283)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPk);
export default __webpack_public_path__ + "static/media/PK.79f0dd88cdc1cec358cb0c943e5d10b7.svg";
export { ForwardRef as ReactComponent };